import { restApiDP } from "@plannel/services/utils/rest-api";
import ResponseUtil from "@plannel/pages/utils/response-util";

const user = JSON.parse(localStorage.getItem("user"));
const getLeaderboard = (params) => {
    return restApiDP.post("/api/bf-leaderboard", params)
};

const getLeaderboardHistorySales = (params) => {
    return restApiDP.get("/api/bf-leaderboard/history-sales", { params })
};

const getAllForCSV = params => {
    return restApiDP.post("/api/bf-leaderboard/csv", params);
};

const getAllForRawCSV = params => {
    return fetch(`/api/bf-leaderboard/raw-csv`, {
        body: ResponseUtil.getExportParamsForPost(params),
        method: "POST",
        headers: {
            "Content-type": "application/json",
            "x-tenant-id": user.tenantId,
            Authorization: `${user.type} ${user.accessToken}`,
            "x-module-name": "DP"
        }
    });
};

const bfLeaderboardService = {
    getLeaderboard,
    getLeaderboardHistorySales,
    getAllForCSV,
    getAllForRawCSV
};

export default bfLeaderboardService;